import React, { useState, useEffect } from 'react';
import { Select, Table, Modal, Button, DatePicker, message } from 'antd';
import { EditOutlined, RollbackOutlined } from '@ant-design/icons';
import {
  getCourse,
  queryOnlineCoachList,
  appointClass,
} from '@/services/wechat';
import styles from './date.less';
import moment from 'moment';

const { Option } = Select;

const ClassPage = ({ report, dispatch }) => {
  const {
    classOrder,
    customerInfo,
    classStatusList,
    planList,
    planDetailInfo,
  } = report;

  const { planDetailList } = planDetailInfo;
  const classTitle = classOrder !== 'report' ? '训练计划约课' : '体测课约课';
  const [visible, setVisible] = useState(false);
  const [classType, setType] = useState('1');

  const [courseList, setCourseList] = useState([]);
  const [coachList, setCoachList] = useState([]);

  const [coachId, setCoachId] = useState('');
  const [courseId, setCourseId] = useState('');

  const [modalTitle, setTitle] = useState('编辑');
  const [weekNo, setWeekNo] = useState();
  const [startTime, setStartTime] = useState(); // 开始时间
  const [endTime, setEndTime] = useState(); // 结束时间

  const [confirmLoading, setConfirmLoading] = useState(false);
  const [showTip, setShowTip] = useState(false);
  const [endtimeDisabled, setEndtimeDisabled] = useState(true); // 下课时间禁用状态
  const [templateId, setTemplateId] = useState(null);

  const columns = [
    {
      title: '运动日',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (t) => {
        return classStatusList[t];
      },
    },
    {
      title: '教练',
      dataIndex: 'coachModel',
      key: 'coachModel',
      render: (t) => {
        return <span>{t?.nickName}</span>;
      },
    },
    {
      title: '上课时间',
      dataIndex: 'time',
      key: 'time',
      render: (t, r) => {
        return (
          <div>
            {r.startTime && moment(r.startTime).format('YYYY-MM-DD HH:mm')} -
            <br />
            {r.endTime && moment(r.endTime).format('YYYY-MM-DD HH:mm')}
          </div>
        );
      },
    },
    {
      title: '操作',
      render: (t, r) => {
        return (
          <EditOutlined
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setVisible(true);
              setCoachId(r.coachId);
              setCourseId(r.courseId);
              setStartTime(r.startTime && moment(r.startTime));
              setEndTime(r.endTime && moment(r.endTime));
            }}
          />
        );
      },
    },
  ];

  const planColumns = [
    {
      title: '运动日',
      dataIndex: 'courseName',
      key: 'courseName',
    },
    {
      title: '状态',
      dataIndex: 'courseStatus',
      key: 'courseStatus',
      render: (t) => {
        return classStatusList[t];
      },
    },
    {
      title: '教练',
      dataIndex: 'coachName',
      key: 'coachName',
      render: (t) => {
        return <span>{t ? JSON.parse(t).nickName : ''}</span>;
      },
    },
    {
      title: '上课时间',
      dataIndex: 'time',
      key: 'time',
      render: (t, r) => {
        return (
          <div>
            {r.startTime && moment(r.startTime).format('YYYY-MM-DD HH:mm')} -
            <br />
            {r.endTime && moment(r.endTime).format('YYYY-MM-DD HH:mm')}
          </div>
        );
      },
    },
    {
      title: '操作',
      render: (t, r) => {
        return (
          <EditOutlined
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setVisible(true);
              setCoachId(r.coachId);
              setCourseId(r.courseId);
              setStartTime(r.startTime && moment(r.startTime));
              setEndTime(r.endTime && moment(r.endTime));
            }}
          />
        );
      },
    },
  ];

  const disabledDate = (current) => {
    return current && current < moment().startOf('days');
  };
  const disabledEndDate = (current) => {
    if (startTime) {
      return current && current < moment(startTime);
    }
    return current && current < moment().startOf('days');
  };

  const getCourseList = async () => {
    const { code, data, msg } = await getCourse({
      requestData: {
        classType: classOrder === 'report' ? '1' : '2',
        userId: customerInfo.customerId,
        pageNo: 1,
        pageSize: 100,
      },
    });
    if (code === '00000') {
      setCourseList(data.classRoomList);
    } else {
      message.error(msg);
    }
  };

  const queryCoachList = async () => {
    let mineInfo = JSON.parse(localStorage.getItem('mineInfo'));
    const { code, data, msg } = await queryOnlineCoachList({
      requestData: {
        userId: mineInfo.userId,
      },
      page: {
        currentPage: 1,
        pageSize: 100,
      },
    });
    if (code === '00000') {
      setCoachList(data);
      setCoachId(data[0].coachId);
    } else {
      message.error(msg);
    }
  };

  const saveData = async () => {
    if (!templateId && classOrder === 'report') {
      return message.error('请选择模板');
    }

    if (!startTime || !endTime) {
      return message.error('时间不能为空');
    }

    setConfirmLoading(true);
    console.log(templateId);
    const { code, msg } = await appointClass({
      requestData: {
        classType,
        userId: customerInfo.customerId,
        coachId,
        courseId,
        templateId,
        startTime: startTime.valueOf(),
        endTime: endTime.valueOf(),
      },
    });
    setConfirmLoading(false);
    if (code === '00000') {
      message.success('保存成功');
      setVisible(false);
      setStartTime(null);
      setEndTime(null);
      setShowTip(false);
      if (classType === '1') {
        getCourseList();
      } else {
        selectWeek(weekNo);
      }
    } else {
      message.error(msg);
    }
  };

  const selectWeek = async (e) => {
    setWeekNo(e);
    dispatch({
      type: 'report/queryPlanDetail',
      payload: {
        weekNo: e,
        innerUserId: report.customerInfo.customerId,
        toPage: false,
      },
    });
  };

  const changeStartDate = (e) => {
    if (e) {
      const currentDate = moment(new Date()).add(2, 'h');
      const endDate = moment(e).add(45, 'm');
      setShowTip(currentDate.isAfter(e));
      setEndTime(endDate);
    } else {
      setEndTime(null);
      setShowTip(false);
    }
    setStartTime(e);
  };

  useEffect(() => {
    queryCoachList();
  }, []);

  useEffect(() => {
    const types = classOrder === 'report' ? '1' : '2';
    setType(types);
    if (types === '1') {
      getCourseList();
    }
    if (types === '2') {
      // 获取默认周， 履约中优先
      let defaultWeekNo = planList[0]?.weekNo;
      const findDefaultWeekIndex = planList.findIndex(
        (i) => +i.perfomStatus === 1,
      );
      if (findDefaultWeekIndex > -1) {
        defaultWeekNo = planList[findDefaultWeekIndex].weekNo;
      }
      setWeekNo(defaultWeekNo);
      selectWeek(defaultWeekNo);
    }
  }, [classOrder]);

  useEffect(() => {
    setCourseList(planDetailList);
  }, [planDetailList]);

  useEffect(() => {
    setEndtimeDisabled(!startTime);
  }, [startTime]);

  const templeteList = [
    {
      id: 11,
      name: '老年人体测',
    },
    {
      id: 13,
      name: '普通体测',
    },
  ];

  return (
    <div>
      <header
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 20,
          fontWeight: 'bold',
          marginBottom: 10,
        }}
      >
        {classTitle}
        {classOrder === 'report' ? (
          <Button
            onClick={() => {
              setVisible(true);
              setTitle('新增');
            }}
            type="link"
          >
            新增
          </Button>
        ) : null}
        <RollbackOutlined
          onClick={() => {
            dispatch({
              type: 'report/changePage',
              payload: {
                page: 0,
              },
            });
          }}
        />
      </header>
      {classOrder === 'plan' ? (
        <div style={{ marginBottom: 10 }}>
          <Select
            value={weekNo}
            onChange={(e) => selectWeek(e)}
            style={{ width: 180 }}
            placeholder="请选择周计划"
          >
            {planList.map((i) => (
              <Option key={i.id} value={i.weekNo}>
                第{i.weekNo}周计划
              </Option>
            ))}
          </Select>
        </div>
      ) : null}
      <Table
        columns={classType === '2' ? planColumns : columns}
        dataSource={courseList}
        rowKey={(r) => r.courseId || r.id}
      />
      <Modal
        title={modalTitle}
        visible={visible}
        onOk={() => {
          saveData();
        }}
        confirmLoading={confirmLoading}
        onCancel={() => {
          setVisible(false);
          setStartTime(null);
          setEndTime(null);
          setCoachId(coachList[0].coachId);
          setCourseId();
          setShowTip(false);
        }}
        maskClosable={false}
      >
        <div className="antd-date-wrap">
          <Select
            size="small"
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 180, marginBottom: 20 }}
            placeholder="请选择教练"
            value={coachId}
            onChange={(e) => {
              setCoachId(e);
            }}
          >
            {coachList.map((i) => (
              <Option key={i.coachId} value={i.coachId}>
                {i.nickName}
              </Option>
            ))}
          </Select>
          {classOrder === 'report' ? (
            <div className="antd-date-wrapper">
              <Select
                size="small"
                placeholder="请选择模板"
                value={templateId}
                style={{ width: 180, marginBottom: 20 }}
                onChange={(e) => {
                  setTemplateId(e);
                }}
              >
                {templeteList.map((i) => (
                  <Option key={i.id} value={i.id}>
                    {i.name}
                  </Option>
                ))}
              </Select>
            </div>
          ) : (
            ''
          )}

          <div className="antd-date-wrapper">
            <DatePicker
              dropdownClassName={styles.dropdownWrap}
              style={{ marginBottom: 10 }}
              disabledDate={disabledDate}
              format="YYYY-MM-DD HH: mm"
              showTime={{
                format: 'HH: mm',
              }}
              placeholder="上课时间"
              value={startTime}
              onChange={(e) => {
                changeStartDate(e);
              }}
            />
            <div
              style={{
                color: 'red',
                margin: '5px 0',
                display: showTip ? 'block' : 'none',
              }}
            >
              距离开课时间较近，请确认上课时间
            </div>
            <DatePicker
              dropdownClassName={styles.dropdownWrap}
              disabled={endtimeDisabled}
              disabledDate={disabledEndDate}
              format="YYYY-MM-DD HH: mm"
              showTime={{
                format: 'HH: mm',
              }}
              placeholder="下课时间"
              value={endTime}
              onChange={(e) => {
                setEndTime(e);
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ClassPage;
